import QuotationDetail from './QuotationDetailContainer';

export default QuotationDetail;
